import React from 'react';
import { ColumnInstance, TableInstance } from 'react-table';

export interface GridContextProps<D extends object> {
  instance: TableInstance<D>;
  paginationSize: number[];
  showLoader: boolean;
  setShowLoader: (value: boolean) => void;
  totalRows: number;
  fetchData: () => Promise<void>;
  hidePagination: boolean;
  columnsOrder: ColumnInstance<D>[];
  setColumnsOrder: React.Dispatch<React.SetStateAction<ColumnInstance<D>[]>>;
}

export const GridTableContext = React.createContext<GridContextProps<any>>(Object.assign({}));
